import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as participantsApi from '../../../../services/api/participantsApi';
import * as drawerActions from '../../../../actions/drawerActions';
import * as messageAlert from '../../../../actions/messageAlertAction';
import * as classroomActions from '../../../../actions/classroom/classroomActions';
import { I18n } from 'react-redux-i18n-lite';

import { DrawerCommonPanelCustom } from './AddUserComponents';
import { PARTICIPANTS_ROLE_SELECTION as OPTIONS, ROLE } from '../../../../const';
import UserView from './UserView';
import RoleView from './RoleView';

class AddUserToClassroom extends Component {
  state = {
    query: '',
    perPage: 10,
    users: [],
    hasMoreItems: true,
    selectedUsers: [],
    teacherRoleMenu: false,
    selectValues: [],
    selectedRole: {},
    open: undefined,
    remountComponent: 0,
    currentPage: 0, // <-- Añadir el estado de la página actual
    isLoading: false // <-- Añadir el estado de carga
  };

  componentDidMount() {
    const options = OPTIONS.map(option => ({
      ...option,
      name: I18n.t(option.name)
    }));

    this.setState({ selectValues: options, selectedRole: options[0] });
  }

  handlePrimaryButtonClick = async () => {
    const { selectedUsers, selectedRole } = this.state;
    const { idClassroom, activeClassroomTab, drawerActions, classroomActions, classroomGroupActions, groupId, classroom } = this.props;

    try {
      await participantsApi
        .postNewParticipants(
          selectedUsers,
          idClassroom,
          activeClassroomTab === 'TEACHERS' ? selectedRole.value : ROLE.STUDENT
        )
        .then(async () => {
          if (activeClassroomTab !== 'TEACHERS') {
            classroomActions.setClassroomStudentsCount(idClassroom, selectedUsers.length);
          }
        });
      drawerActions.closeDrawerAndRemoveContent();
    } catch (err) {
      drawerActions.closeDrawerAndRemoveContent();
      messageAlert.error(I18n.t('participants.messageAlert.participantsError'));
    }
  };

  loadItems = async () => {
    const { idClassroom, idInstitution, drawerActions, messageAlert, activeClassroomTab } = this.props;
    const { perPage, query, currentPage, isLoading } = this.state;
    if (isLoading) return;
    this.setState({ isLoading: true });
    try {
      const users = await participantsApi.getParticipantsPage(
        idInstitution,
        idClassroom,
        currentPage + 1,
        perPage,
        query,
        activeClassroomTab === 'TEACHERS' ? ROLE.INSTRUCTOR : ROLE.STUDENT
      );

      if (users._embedded && users._embedded.usersList && users._embedded.usersList.length) {
        this.setState({
          users: [...this.state.users, ...users._embedded.usersList],
          currentPage: currentPage + 1,
          hasMoreItems: users._embedded.usersList.length === perPage
        });
      } else {
        this.setState({
          hasMoreItems: false
        });
      }
    } catch (err) {
      drawerActions.closeDrawerAndRemoveContent();
      messageAlert.error(I18n.t('participants.messageAlert.participantsError'));
    } finally {
      this.setState({ isLoading: false }); // <-- Terminar el estado de carga
    }
  };

  updateQuery = query => {
    this.setState({
      query,
      users: [],
      hasMoreItems: true,
      currentPage: 0, // <-- Reseteo de la página actual
      isLoading: false, // <-- Reseteo del estado de carga
      remountComponent: this.state.remountComponent + 1
    });
  };

  handleOnChange = query => {
    this.updateQuery(query);
  };

  handleOnUserClick = user => {
    const { selectedUsers } = this.state;

    if (this.isTeacherTab()) {
      this.setState({ selectedUsers: [user], teacherRoleMenu: true });
    } else {
      const isSelected = selectedUsers.filter(u => user._id === u._id).length > 0;

      if (isSelected) {
        this.setState({
          selectedUsers: selectedUsers.filter(u => user._id !== u._id)
        });
      } else {
        this.setState({
          selectedUsers: [...selectedUsers, user]
        });
      }
    }
  };

  isTeacherTab = () => this.props.activeClassroomTab === 'TEACHERS';

  handleClickMenuItem = option => {
    this.setState({ selectedRole: option });
  };

  backToMenuA = () => {
    this.setState({
      teacherRoleMenu: false,
      selectedUsers: []
    });
  };

  render() {
    const { teacherRoleMenu, selectedUsers, users, hasMoreItems, selectedRole, remountComponent } = this.state;
    const { drawerActions, selectedClassroomName } = this.props;
    const isMenuHidden = selectedUsers.length === 0;
    const title = this.isTeacherTab()
      ? 'participants.drawer.teachers.boldText'
      : 'participants.drawer.students.boldText';

    const style = this.isTeacherTab()
      ? teacherRoleMenu
        ? 'multiple-selection-panel teacher-role-menu'
        : 'multiple-selection-panel teacher-user-menu'
      : isMenuHidden
      ? 'multiple-selection-panel hidden-menu'
      : 'multiple-selection-panel show-menu';

    const buttonText = this.isTeacherTab()
      ? I18n.t('common.add')
      : selectedUsers.length > 0
      ? `${I18n.t('common.add')} (${selectedUsers.length})`
      : I18n.t('common.add');

    return (
      <DrawerCommonPanelCustom
        closePanel={drawerActions.closeDrawerAndRemoveContent}
        hideRowButtons={isMenuHidden}
        panelHeaderTitle={
          this.isTeacherTab()
            ? I18n.t('participants.drawer.teachers.title')
            : I18n.t('participants.drawer.students.title')
        }
        showCancelButton={true}
        handleSecondaryButtonClick={this.backToMenuA}
        primaryButtonText={buttonText}
        secondaryButtonText={teacherRoleMenu && 'common.back'}
        icon={teacherRoleMenu && 'left-chevron'}
        onPrimaryButtonClick={this.handlePrimaryButtonClick}
        data-cy="addUserToClassroomDrawer"
      >
        {!teacherRoleMenu ? (
          <UserView
            title={I18n.t(title)}
            users={users}
            selectedUsers={selectedUsers}
            showSearchArea={true}
            hasMoreItems={hasMoreItems}
            resetPageNumber={remountComponent}
            events={{
              onUserClick: user => this.handleOnUserClick(user),
              onLoadMoreItems: () => this.loadItems(),
              onSearchChange: query => this.handleOnChange(query)
            }}
            className={{
              userList: style
            }}
          />
        ) : (
          <RoleView
            user={selectedUsers[0]}
            selectedRole={selectedRole}
            selectedClassroomName={selectedClassroomName}
            events={{
              onChange: option => this.handleClickMenuItem(option)
            }}
            className={{
              select: style
            }}
          />
        )}
      </DrawerCommonPanelCustom>
    );
  }
}

AddUserToClassroom.propTypes = {
  idClassroom: PropTypes.string,
  idInstitution: PropTypes.number,
  drawerActions: PropTypes.object,
  messageAlert: PropTypes.object,
  activeClassroomTab: PropTypes.string,
  colors: PropTypes.any,
  selectedClassroomName: PropTypes.string,
  classroomActions: PropTypes.any
};

const mapDispatchToProps = dispatch => ({
  messageAlert: bindActionCreators(messageAlert, dispatch),
  drawerActions: bindActionCreators(drawerActions, dispatch),
  classroomActions: bindActionCreators(classroomActions, dispatch),
  classroomGroupActions: bindActionCreators(require('../../../../actions/classroom/classroomGroupActions'), dispatch),
  dispatch
});

const mapStateToProps = state => ({
  idClassroom: state.router.params.idClassroom,
  idInstitution: state.school.school.id,
  activeClassroomTab: state.classrooms.selectedClassroom.activeClassroomTab,
  selectedClassroomName: state.classrooms.selectedClassroom.classroom.name,
  colors: state.theme.colors,
  groupId: state.selectedGroup.group.id,
  classroom: state.classrooms.selectedClassroom.classroom
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUserToClassroom);
